<template>
  <svg class="title" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
   viewBox="0 0 782 327.3" style="enable-background:new 0 0 782 327.3;" xml:space="preserve">
    <g>
      <linearGradient id="fill_1_1" gradientUnits="userSpaceOnUse" x1="393.479" y1="11.6532" x2="393.479" y2="220.3911">
        <stop  offset="0" style="stop-color:#3E9042"/>
        <stop  offset="1" style="stop-color:#8CA742"/>
      </linearGradient>
      <path class="write-1" style="fill:url(#fill_1_1);" d="M185.9,75.3c-9.2,26-34.5,41.7-57.7,49.6c16.2,6.4,28.5,19.6,24.7,38.6
        c-5.5,27.1-47.7,62.8-79.7,56c-13.4-2.8-20.7-18.1-18.5-23.9C103,206.8,156.1,158,139,141.6c-13-12.4-32.2-11.3-44.5-8.5
        c-9.8,23.4-17.5,44.5-17.7,53c0,0.9-0.4,2.6-4.7,2.3C67,188.2,56,178,56.6,170.8c13-41.1,49-106.3,64.3-124
        c4.3-4.9,18.5,2.8,14.5,7.9c-7.9,10.2-20,33.2-31.3,57.5c62.6-10.4,73.9-50.7,72.4-61.8c-3.4-25.3-43.2-20.7-65-11.9
        C93,46,78.5,60,74.1,66.6c-0.9,1.3-3,2.6-4.9-0.9c-2.8-5.1-6.4-13.4-6-18.1C64.5,29.1,116.9,3.8,152,14
        C180.1,22.1,195.7,47.4,185.9,75.3z"/>
      <linearGradient id="fill_1_2" gradientUnits="userSpaceOnUse" x1="393.479" y1="11.6532" x2="393.479" y2="220.3911">
        <stop  offset="0" style="stop-color:#3E9042"/>
        <stop  offset="1" style="stop-color:#8CA742"/>
      </linearGradient>
      <path class="write-1" style="fill:url(#fill_1_2);" d="M220.6,128.8c-6.6,12.1-8.9,17.3-20.9,35.6c-5.8,8.7-14.5,17.5-24.3,17.5
        c-12.1,0-15.5-10.2-15.1-19c1.1-19.4,17.7-55.2,29.2-72c2.8-3.8,22.6,4.3,17.9,11.7c-18.5,29.2-34.5,67.5-26.6,67.5
        c6.6,0,24.9-26.6,35.6-43.5c1.3-1.7,3-3.8,4.7-3.2C222.3,123.9,222.5,125.2,220.6,128.8z M236.2,55.5c-3.4,7-16,25.6-20.9,25.6
        c-3.6,0-8.9-4-8.9-10.2c0-7,7.7-25.3,17.9-25.3C230.8,45.5,237.6,52.6,236.2,55.5z"/>
      <linearGradient id="fill_1_3" gradientUnits="userSpaceOnUse" x1="393.479" y1="11.6532" x2="393.479" y2="220.3911">
        <stop  offset="0" style="stop-color:#3E9042"/>
        <stop  offset="1" style="stop-color:#8CA742"/>
      </linearGradient>
      <path class="write-1" style="fill:url(#fill_1_3);" d="M293.9,112.6c-1.7,15.1-26,71.4-48.1,71.4c-14.3,0-20.9-12.8-23.2-17.7
        c-0.2-0.4-0.2-0.9-0.4-1.3c-1.5,4.7-2.8,9.4-3.6,13.6c-0.4,1.7,0,3.4-3,3.4c-6.6,0-18.7-7-15.8-15.8
        c17.3-49.8,57.1-119.7,62.8-128.4c2.3-3.8,23.2,7.7,18.3,14.7c-7.2,10.6-20,30.7-30.7,50.3c7.5-8.9,17.3-17.5,24.3-17.5
        C290.3,85.4,295.2,99.6,293.9,112.6z M276,93.7c-4.7-2.6-29,19-50.7,65.4c0,3.6,2.3,8.7,5.3,8.7C258.3,167.8,281.1,96.4,276,93.7z
        "/>
      <linearGradient id="fill_1_4" gradientUnits="userSpaceOnUse" x1="393.479" y1="11.6532" x2="393.479" y2="220.3911">
        <stop  offset="0" style="stop-color:#3E9042"/>
        <stop  offset="1" style="stop-color:#8CA742"/>
      </linearGradient>
      <path class="write-1" style="fill:url(#fill_1_4);" d="M308.6,170.3c6.4,0,25.1-26.8,34.9-43.5c1.1-1.9,2.8-3.8,4.5-3.2c1.5,0.2,1.7,1.7-0.2,5.3
        c-5.3,9.6-13.6,26-20.9,35.4c-6.2,8.1-13.4,17.7-23,17.7c-12.1,0-16.2-10.4-16.2-19c0-34.7,42.2-100.7,52.8-117.4
        c2.6-4,23.4,7.5,18.5,14.7C339.2,89,293,170.3,308.6,170.3z"/>
      <linearGradient id="fill_1_5" gradientUnits="userSpaceOnUse" x1="393.479" y1="11.6532" x2="393.479" y2="220.3911">
        <stop  offset="0" style="stop-color:#3E9042"/>
        <stop  offset="1" style="stop-color:#8CA742"/>
      </linearGradient>
      <path class="write-1" style="fill:url(#fill_1_5);" d="M393.8,128.8c-6.6,12.1-8.9,17.3-20.9,35.6c-5.8,8.7-14.5,17.5-24.3,17.5
        c-12.1,0-15.5-10.2-15.1-19c1.1-19.4,17.7-55.2,29.2-72c2.8-3.8,22.6,4.3,17.9,11.7c-18.5,29.2-34.5,67.5-26.6,67.5
        c6.6,0,24.9-26.6,35.6-43.5c1.3-1.7,3-3.8,4.7-3.2C395.5,123.9,395.7,125.2,393.8,128.8z M409.3,55.5c-3.4,7-16,25.6-20.9,25.6
        c-3.6,0-8.9-4-8.9-10.2c0-7,7.7-25.3,17.9-25.3C404,45.5,410.8,52.6,409.3,55.5z"/>
      <linearGradient id="fill_1_6" gradientUnits="userSpaceOnUse" x1="393.479" y1="11.6532" x2="393.479" y2="220.3911">
        <stop  offset="0" style="stop-color:#3E9042"/>
        <stop  offset="1" style="stop-color:#8CA742"/>
      </linearGradient>
      <path class="write-1" style="fill:url(#fill_1_6);" d="M468.7,126.5c-6,12.4-17,28.5-30,29.2c-14.5,24.1-30.5,29.2-42.8,26.2
        c-13.4-3.2-24.3-21.1-12.6-51.1c13-33.9,34.9-49.6,55.6-45.2c12.8,2.8,21.5,18.1,12.6,43c-2.1,5.8-4.5,11.3-6.8,16
        c7-1.3,14.1-8.3,20-19C467.5,120.9,470,123.5,468.7,126.5z M428.1,151.2c-4.5-8.1,2.6-27.3,12.1-29.2c4.9-15.5,3.6-24.9-3-26.2
        c-12.6-2.6-27.1,20-34.9,39.4c-6,14.7-7,30.2,1.5,32.6C412.9,170.1,421.2,163.1,428.1,151.2z"/>
      <linearGradient id="fill_1_7" gradientUnits="userSpaceOnUse" x1="393.479" y1="11.6532" x2="393.479" y2="220.3911">
        <stop  offset="0" style="stop-color:#3E9042"/>
        <stop  offset="1" style="stop-color:#8CA742"/>
      </linearGradient>
      <path class="write-1" style="fill:url(#fill_1_7);" d="M519.4,83.3c-2.6,0-6,0-9.7,0c-21.8,35.8-48.5,88.2-36,88.2c6.5,0,25.5-27,35.4-44
        c1.1-1.7,2.8-3.7,4.5-3.2c1.3,0.4,1.7,1.7-0.4,5.4c-5.2,9.9-13.8,26.5-20.9,36c-6.5,8.2-13.6,17.7-23.5,17.7
        c-12.1,0-16.2-10.4-16.2-19.2c0-21.4,15.7-54.4,30.6-80.9c-1.9,0-3.9,0-5.4,0c-4.3,0-6.7-10.6-1.5-10.8c1.5-0.2,6.7-0.2,13.2-0.2
        c4.7-8.2,9.3-15.3,12.5-20.5c5.6-8.8,23.9,6.7,19.8,12.5c-1.5,2.6-3.2,5.2-5.2,8c3.5,0,7.5,0,9.9,0
        C531,72.3,527.1,83.3,519.4,83.3z"/>
      <linearGradient id="fill_1_8" gradientUnits="userSpaceOnUse" x1="393.479" y1="11.6532" x2="393.479" y2="220.3911">
        <stop  offset="0" style="stop-color:#3E9042"/>
        <stop  offset="1" style="stop-color:#8CA742"/>
      </linearGradient>
      <path class="write-1" style="fill:url(#fill_1_8);" d="M580.4,125.8c-0.2,1.7-27.7,59-55.2,56.4c-20.7-1.9-26.2-16.8-23.6-33.9
        c3-22.4,22.4-65.2,50.5-62.4c13.2,1.3,17.7,7,19.2,15.5c3,15.8-16.2,40.5-38.3,34.5c-2.1-0.4-3.8-1.5-4.7-2.8
        c-7,16.4-9.8,33.2-1.1,36.8c17.5,7.7,46.6-39.8,48.8-44.1C577.8,121.8,580.8,122.8,580.4,125.8z M531.2,126.9
        c25.3-4.7,32.8-26.4,26.6-28.1C550.5,96.4,539,110.7,531.2,126.9z"/>
      <linearGradient id="fill_1_9" gradientUnits="userSpaceOnUse" x1="393.479" y1="11.6532" x2="393.479" y2="220.3911">
        <stop  offset="0" style="stop-color:#3E9042"/>
        <stop  offset="1" style="stop-color:#8CA742"/>
      </linearGradient>
      <path class="write-1" style="fill:url(#fill_1_9);" d="M588,181.8c-20.7-1.9-26.2-16.8-23.9-33.9c3.2-22.4,22.6-65.4,50.7-62.6
        c13.2,1.3,17.9,9.8,17.9,14.9c0.2,11.3-5.8,19.8-11.9,19.8c-3.8,0-3-3.4-1.9-4.5c3.8-4.3,8.1-15.5,1.7-17.5
        c-15.3-4.5-49.2,63.5-30.7,71.6c17.3,7.5,43.2-39.8,45.4-44.1c1.9-4.3,4.9-3.2,4.5-0.4C639.6,127.1,615.5,184.2,588,181.8z"/>
      <linearGradient id="fill_1_10" gradientUnits="userSpaceOnUse" x1="393.479" y1="11.6532" x2="393.479" y2="220.3911">
        <stop  offset="0" style="stop-color:#3E9042"/>
        <stop  offset="1" style="stop-color:#8CA742"/>
      </linearGradient>
      <path class="write-1" style="fill:url(#fill_1_10);" d="M731.2,128.8c-5.1,9.8-13.6,26.2-20.7,35.6c-6.4,8.1-13.4,17.5-23.2,17.5
        c-11.9,0-16-10.2-16-18.7c0-3.4,0.6-7.2,1.7-11.5c-9.8,15.1-21.1,30-29,30c-17,0-20-13.4-20-20.2c0-23.2,26.6-75.4,53.7-75.4
        c11.7,0,16.8,6.6,18.3,13.8c2.8-4.5,4.9-7.5,6-8.1c4.3-2.1,25.1,9.2,18.5,14.7c-9.8,8.1-39.6,63.7-28.3,63.7
        c6.4,0,25.1-26.6,34.9-43.5c1.1-1.7,2.8-3.6,4.5-3.2C732.9,123.9,733.3,125.2,731.2,128.8z M686.8,114.1
        c3.2-6.6,3.2-12.6,0.2-13.6c-13-4.5-42.8,51.8-42.8,66.7c0,1.9,0.6,3,1.7,3C652.8,170.1,678.1,131.2,686.8,114.1z"/>
    </g>
    <g>
      <linearGradient id="fill_2_1" gradientUnits="userSpaceOnUse" x1="388.7736" y1="290.9608" x2="388.7736" y2="217.3">
        <stop  offset="0" style="stop-color:#E5E2DF"/>
        <stop  offset="0" style="stop-color:#D6D3D1"/>
        <stop  offset="0" style="stop-color:#AFADAB"/>
        <stop  offset="0" style="stop-color:#706F6E"/>
        <stop  offset="0" style="stop-color:#212121"/>
        <stop  offset="0.1656" style="stop-color:#262626"/>
        <stop  offset="0.3691" style="stop-color:#353535"/>
        <stop  offset="0.5926" style="stop-color:#4E4E4E"/>
        <stop  offset="0.8287" style="stop-color:#717171"/>
        <stop  offset="1" style="stop-color:#8F8F8F"/>
      </linearGradient>
      <path class="write-2" style="fill:url(#fill_2_1);" d="M286,217.3h15.6l-24.5,72h-14.2l-24.3-72h16.1l15.6,54.7L286,217.3z"/>
      <linearGradient id="fill_2_2" gradientUnits="userSpaceOnUse" x1="388.7736" y1="290.9608" x2="388.7736" y2="217.3">
        <stop  offset="0" style="stop-color:#E5E2DF"/>
        <stop  offset="0" style="stop-color:#D6D3D1"/>
        <stop  offset="0" style="stop-color:#AFADAB"/>
        <stop  offset="0" style="stop-color:#706F6E"/>
        <stop  offset="0" style="stop-color:#212121"/>
        <stop  offset="0.1656" style="stop-color:#262626"/>
        <stop  offset="0.3691" style="stop-color:#353535"/>
        <stop  offset="0.5926" style="stop-color:#4E4E4E"/>
        <stop  offset="0.8287" style="stop-color:#717171"/>
        <stop  offset="1" style="stop-color:#8F8F8F"/>
      </linearGradient>
      <path class="write-2" style="fill:url(#fill_2_2);" d="M322,230.3h-14v-13h14V230.3z M308,236.3h14v53h-14V236.3z"/>
      <linearGradient id="fill_2_3" gradientUnits="userSpaceOnUse" x1="388.7736" y1="290.9608" x2="388.7736" y2="217.3">
        <stop  offset="0" style="stop-color:#E5E2DF"/>
        <stop  offset="0" style="stop-color:#D6D3D1"/>
        <stop  offset="0" style="stop-color:#AFADAB"/>
        <stop  offset="0" style="stop-color:#706F6E"/>
        <stop  offset="0" style="stop-color:#212121"/>
        <stop  offset="0.1656" style="stop-color:#262626"/>
        <stop  offset="0.3691" style="stop-color:#353535"/>
        <stop  offset="0.5926" style="stop-color:#4E4E4E"/>
        <stop  offset="0.8287" style="stop-color:#717171"/>
        <stop  offset="1" style="stop-color:#8F8F8F"/>
      </linearGradient>
      <path class="write-2" style="fill:url(#fill_2_3);" d="M364.8,235.1c0.2,0,0.6,0,1.2,0.1v14.1c-0.9-0.1-1.7-0.2-2.4-0.2c-0.7,0-1.2,0-1.7,0
        c-5.6,0-9.4,1.8-11.3,5.5c-1.1,2.1-1.6,5.2-1.6,9.5v25.3h-14v-53h13v9.3c2.2-3.5,4.1-6,5.7-7.3c2.7-2.2,6.1-3.3,10.4-3.3
        C364.4,235,364.6,235,364.8,235.1z"/>
      <linearGradient id="fill_2_4" gradientUnits="userSpaceOnUse" x1="388.7736" y1="290.9608" x2="388.7736" y2="217.3">
        <stop  offset="0" style="stop-color:#E5E2DF"/>
        <stop  offset="0" style="stop-color:#D6D3D1"/>
        <stop  offset="0" style="stop-color:#AFADAB"/>
        <stop  offset="0" style="stop-color:#706F6E"/>
        <stop  offset="0" style="stop-color:#212121"/>
        <stop  offset="0.1656" style="stop-color:#262626"/>
        <stop  offset="0.3691" style="stop-color:#353535"/>
        <stop  offset="0.5926" style="stop-color:#4E4E4E"/>
        <stop  offset="0.8287" style="stop-color:#717171"/>
        <stop  offset="1" style="stop-color:#8F8F8F"/>
      </linearGradient>
      <path class="write-2" style="fill:url(#fill_2_4);" d="M369,246.3v-10h7v-15h14v15h9v10h-9v28.4c0,2.2,0.3,3.6,0.9,4.1c0.6,0.5,2.3,0.8,5.3,0.8
        c0.4,0,0.9,0,1.4,0c0.5,0,1,0,1.4-0.1v10.3l-6.5,0.2c-6.5,0.2-10.9-0.9-13.2-3.4c-1.5-1.6-2.3-4-2.3-7.2v-33.1H369z"/>
      <linearGradient id="fill_2_5" gradientUnits="userSpaceOnUse" x1="388.7736" y1="290.9608" x2="388.7736" y2="217.3">
        <stop  offset="0" style="stop-color:#E5E2DF"/>
        <stop  offset="0" style="stop-color:#D6D3D1"/>
        <stop  offset="0" style="stop-color:#AFADAB"/>
        <stop  offset="0" style="stop-color:#706F6E"/>
        <stop  offset="0" style="stop-color:#212121"/>
        <stop  offset="0.1656" style="stop-color:#262626"/>
        <stop  offset="0.3691" style="stop-color:#353535"/>
        <stop  offset="0.5926" style="stop-color:#4E4E4E"/>
        <stop  offset="0.8287" style="stop-color:#717171"/>
        <stop  offset="1" style="stop-color:#8F8F8F"/>
      </linearGradient>
      <path class="write-2" style="fill:url(#fill_2_5);" d="M421,236.3v32.1c0,3,0.4,5.3,1.1,6.8c1.3,2.7,3.8,4.1,7.6,4.1c4.8,0,8.1-1.9,9.9-5.8
        c0.9-2.1,1.4-4.8,1.4-8.3v-29h14v53h-13v-7.5c-0.1,0.2-0.4,0.6-1,1.5c-0.5,0.8-1.1,1.5-1.8,2.1c-2.1,1.9-4.2,3.3-6.2,4
        c-2,0.7-4.4,1.1-7,1.1c-7.8,0-13-2.8-15.7-8.5c-1.5-3.1-2.3-7.7-2.3-13.8v-31.9H421z"/>
      <linearGradient id="fill_2_6" gradientUnits="userSpaceOnUse" x1="388.7736" y1="290.9608" x2="388.7736" y2="217.3">
        <stop  offset="0" style="stop-color:#E5E2DF"/>
        <stop  offset="0" style="stop-color:#D6D3D1"/>
        <stop  offset="0" style="stop-color:#AFADAB"/>
        <stop  offset="0" style="stop-color:#706F6E"/>
        <stop  offset="0" style="stop-color:#212121"/>
        <stop  offset="0.1656" style="stop-color:#262626"/>
        <stop  offset="0.3691" style="stop-color:#353535"/>
        <stop  offset="0.5926" style="stop-color:#4E4E4E"/>
        <stop  offset="0.8287" style="stop-color:#717171"/>
        <stop  offset="1" style="stop-color:#8F8F8F"/>
      </linearGradient>
      <path class="write-2" style="fill:url(#fill_2_6);" d="M489.5,256.9c2.6-0.3,4.5-0.7,5.6-1.2c2-0.8,3-2.2,3-4c0-2.2-0.8-3.7-2.3-4.5
        c-1.5-0.8-3.8-1.2-6.8-1.2c-3.4,0-5.7,0.8-7.1,2.4c-1,1.2-1.7,2.8-2,4.9h-13.5c0.3-4.7,1.6-8.5,4-11.5c3.7-4.7,10.1-7,19.2-7
        c5.9,0,11.1,1.2,15.7,3.5c4.6,2.3,6.9,6.7,6.9,13.1v24.4c0,1.7,0,3.7,0.1,6.2c0.1,1.8,0.4,3.1,0.8,3.7c0.5,0.7,1.1,1.2,2.1,1.6
        v2.1h-15.2c-0.4-1.1-0.7-2.1-0.9-3c-0.2-0.9-0.3-2-0.4-3.2c-1.9,2.1-4.2,3.9-6.7,5.3c-3,1.7-6.5,2.6-10.3,2.6
        c-4.9,0-8.9-1.4-12.1-4.1c-3.2-2.8-4.8-6.7-4.8-11.7c0-6.5,2.6-11.3,7.7-14.2c2.8-1.6,6.9-2.7,12.4-3.4L489.5,256.9z M498,263.5
        c-0.9,0.6-1.8,1-2.7,1.3c-0.9,0.3-2.2,0.7-3.7,1l-3.2,0.6c-3,0.5-5.1,1.2-6.4,1.9c-2.2,1.3-3.3,3.2-3.3,5.9c0,2.4,0.7,4.1,2,5.2
        c1.3,1.1,3,1.6,4.9,1.6c3,0,5.8-0.9,8.4-2.6c2.6-1.8,3.9-5,4-9.6V263.5z"/>
      <linearGradient id="fill_2_7" gradientUnits="userSpaceOnUse" x1="388.7736" y1="290.9608" x2="388.7736" y2="217.3">
        <stop  offset="0" style="stop-color:#E5E2DF"/>
        <stop  offset="0" style="stop-color:#D6D3D1"/>
        <stop  offset="0" style="stop-color:#AFADAB"/>
        <stop  offset="0" style="stop-color:#706F6E"/>
        <stop  offset="0" style="stop-color:#212121"/>
        <stop  offset="0.1656" style="stop-color:#262626"/>
        <stop  offset="0.3691" style="stop-color:#353535"/>
        <stop  offset="0.5926" style="stop-color:#4E4E4E"/>
        <stop  offset="0.8287" style="stop-color:#717171"/>
        <stop  offset="1" style="stop-color:#8F8F8F"/>
      </linearGradient>
      <path class="write-2" style="fill:url(#fill_2_7);" d="M539,289.3h-14v-72h14V289.3z"/>
    </g>
  </svg>
</template>

<script>
/* eslint-disable */
import { TweenMax, TimelineMax } from 'gsap'
import SVGDrawPlugin from '../plugins/svgDraw'
export default {
  name: 'TitleLibrary',
  props: {
    enableTrans: Boolean,
    delayTrans: {
      default: 0
    }
  },
  methods:{
  },
  mounted(){
    let vm = this
    if(vm.enableTrans){
      TweenMax.to(".write-1", 0, {fillOpacity:0}, 0);
      TweenMax.to(".write-2", 0, {fillOpacity:0}, 0);
      (new TimelineMax()).delay(vm.delayTrans).staggerFrom(".write-1", 2, {drawSVG:0}, 0.1).staggerTo(".write-1", .5, {fillOpacity:1}, 0.1);
      (new TimelineMax()).delay(vm.delayTrans+1).staggerFrom(".write-2", 2, {drawSVG:0}, 0.1).staggerTo(".write-2", .5, {fillOpacity:1}, 0.1);
    }
  }
}
/* eslint-enable */
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
  .title
    width: 45vw
    height: auto
  .write-1
    stroke: #669c42
  .write-2
    stroke: #888888
</style>
